// extracted by mini-css-extract-plugin
export default {"messages":"messages_messages__AslDs"};